import { useState, useEffect, useCallback } from "react";
import { useRouter } from "next/router";
import { apiRequest } from "../../pages/api/requestHelper";
import config from "../config/app.json";
import { getDecodeTemplateId } from "../helpers/utils";

const apiUrl = config["APIURIS"][config["APIURIS"]["current"]];

function useFetchData() {
  const router = useRouter();
  const [data, setData] = useState({});

  const fetchData = useCallback(async () => {
    const { data } = await apiRequest(
      "get",
      `${apiUrl}dynamic/designs/${router.query.templateId}/`
    );
    if (!!data["data"]) {
      setData(data["data"]);
    }
  }, []);

  useEffect(() => {
    if (!!router.query.templateId) {
      fetchData();
    }
  }, [router.query.templateId]);

  return { modalData: data };
}

export default useFetchData;
